
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    test: "https://test-bot.drep.org",
    production: "https://bot.drep.org",
}
